import { createContext } from 'react';

export const ScheduledInventoryConfigContext = createContext<boolean>(false);
